var IsOpen = false;
var LastItems = [];

export default {
  data() {
    return {
      localBrand: null,
      debug: true
    };
  },

  methods: {
    // Ermittele alle Ordner für die Brands
    getBrandFolders(brands) {
      let items = [];
      brands.forEach(x => {
        if (x.type && !(items.indexOf(x.type) > -1)) {
          items.push(x.type);
        }
      });
      return items;
    },

    // Hole Komplette Brand-Struktur
    getBrands(brands) {
      let items = [];

      // Get all folder names
      let folders = this.getBrandFolders(brands);

      // Create all Folders as the starting Items
      folders.forEach(x => {
        items.push( { "id": x, "label": x, "type": x, "children": [], "isDefaultExpanded": true } );
      });

      // add Items to tree structure
      brands.forEach(x => {
        if (!x.type) {
          // add Items w/o 'type' property at root level
          items.push(x);
        } else {
          // add Items with 'type' property to matching folder
          let parent = _.find(items, ['type', x.type]);
          if (parent) {
            parent.children.push(x);
          } else {
            console.warn('Cannot find parent for: ', x);
          }
        }
      });

      return items;
    },

    getItemById(id) {
      return _.find(this.brandsFlat, [ 'id', id]);
    },

    handleOpenBrand(instanceId) {
      IsOpen = true;
      LastItems = this.selection.Brand;
    },

    handleSelectBrand(value, instanceId) {
      this.localBrand = value;
    },

    handleInputBrand(value, instanceId) {
      // Get all roots (n=New Car, u=Used Car, -1=Motorrad, ...)
      let rootFolder = _.uniq(_.map(value, x => x.substring(0, x.indexOf('^'))));

      // if more than one root is used, remove all previously selected ones
      if (rootFolder.length > 1) {
        for (let index = 0; index < rootFolder.length - 1; index++) {
          const element = rootFolder[index];
          value = _.filter(value, x => element != x.substring(0, x.indexOf('^')));
        }
      }
      if (!value || value.length === 0) {

      } else {
        this.selection.Brand = value;
      }
    },

    handleDeselectBrand(value, instanceId) {
    },

    handleCloseBrand(value, instanceId) {
      IsOpen = false;
      var changed = false;

      if (JSON.stringify(LastItems) != JSON.stringify(this.selection.Brand)) {
        changed = true;
      }

      if (!value || value.length === 0) {
        this.selection.Brand = _.map(this.optionsdata.Brand[0].children, 'id');
        changed = true;
      };

      if (!changed) {
        return;
      }

      this.brandLock = true;

      this.selection.Surveys = []
      this.selection.Waves = []
      this.selection.Regions = []
      this.selection.Subregions = []
      this.selection.NSCs = []
      this.selection.SubNSCs = []
      this.selection.Areas = []
      this.selection.Dealergroups = []
      this.selection.ClientLocations = []
      this.selection.WebsiteAnswers = null

      this.loadData(value, instanceId)
      this.brandLock = false;
    },
  }
}
